import {useState,useEffect} from "react";
import { Button, Select, Form, Input, Menu } from "antd";
import { Link } from "react-router-dom";
import IntlMessages from "util/IntlMessages";
import { useAuth } from "../authentication";
import { ToastContainer, toast } from 'react-toastify';
const SignIn = () => {
  const { isLoading, error, userLogin } = useAuth();
  const [role , setRole] = useState(1);
  const onFinishFailed = (errorInfo) => {};
  let loading = false;
  const onFinish = (values) => {
    userLogin(values);
  };

  const { Option } = Select;

  useEffect(() => {
    if(error && !loading) {
      loading = true ;
      toast.error(
        error
      );
    }
  }, [error])


  return (
    <div className="gx-app-login-wrap">
      <div className="gx-app-login-container">
        <div className="gx-app-login-main-content">
          <div className="gx-app-logo-content">
            <div className="gx-app-logo-content-bg">
            </div>
            <div className="gx-app-logo-wid">
              <h1>
                ورود
              </h1>
              <p>
               نام کاربری و رمز عبور را وارد نمایید
              </p>
            </div>
            <div className="gx-app-logo">
              <img alt="example" src="/assets/images/logo.png" />
            </div>
          </div>
          <div className="gx-app-login-content">
            <Form
              initialValues={{ remember: true }}
              name="basic"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              className="gx-signin-form gx-form-row0"
            >
              <Form.Item
                rules={[
                  { required: true, message: "نام کاربری را وارد نمایید" },
                ]}
                name="username"
              >
                <Input placeholder="نام کاربری" />
              </Form.Item>
              <Form.Item
                rules={[
                  { required: true, message: "رمز عبور را وارد نمایید" },
                ]}
                name="password"
              >
                <Input type="password" placeholder="رمز عبور" />
              </Form.Item>

              <Form.Item>
                <Button loading={isLoading} type="primary" className="gx-mb-0" htmlType="submit">
                  ورود
                </Button>
              </Form.Item>
            </Form>
          </div>
           {/* <ToastContainer /> */}
        </div>
      </div>
    </div>
  );
};

export default SignIn;
